import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { ContractsHttpService } from '../services/contracts/contracts.http.service';
import { DashboardHttpUtil } from '../components/dashboard/dashboard.util';
import { StorageUtil } from '../utils/storage.util';

@Injectable()
export class ContractResolver implements Resolve<any> {

  model: any = {
    data: ''
  };

  constructor(private contractHttpService: ContractsHttpService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // TODO: get data from contract model service or even child need resolver?
    let id = +route.paramMap.get('id');
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    return this.contractHttpService.getSingleContract(id, requestParams);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolves/contract.resolver.ts